import type { ReactNode } from "react";

import { cn } from "src/lib/utils";

interface PageHeadProps {
	title: ReactNode;
	subtitle?: ReactNode;
	/** Right-aligned actions (buttons, filters). Wraps below the title on small screens. */
	actions?: ReactNode;
	className?: string;
}

/** Prototype `.page-head` — page title, optional sub-line, and right-aligned actions. */
const PageHead = ({ title, subtitle, actions, className }: PageHeadProps) => (
	<div className={cn("tw-mb-1.5 tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3.5", className)}>
		<div className="tw-min-w-0">
			<h1 className="tw-mb-1 tw-text-[20px] tw-font-bold tw-text-text sm:tw-text-[23px]">{title}</h1>
			{subtitle && <p className="tw-text-[13.5px] tw-text-text-soft">{subtitle}</p>}
		</div>
		{actions && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">{actions}</div>}
	</div>
);

export default PageHead;
